import React from "react";
import { Button, Popover, Typography, makeStyles } from "@material-ui/core";
import {
  usePopupState,
  bindTrigger,
  bindPopover,
} from "material-ui-popup-state/hooks";

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
    border: "1px solid",
  },
}));

export default function TextButtonWithDocumentation({ label, doc }) {
  const classes = useStyles();
  const popupState = usePopupState({
    variant: "popover",
    popupId: label + "Popover",
  });
  return (
    <>
      <Button {...bindTrigger(popupState)}>{<Typography style={{fontSize:12}}>{label}</Typography>}</Button>
      <Popover
        {...bindPopover(popupState)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Typography className={classes.typography}>{doc}</Typography>
      </Popover>
    </>
  );
}
